import React from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { CardBody } from "reactstrap";
import { PlusIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";

import { CashManagementConfigure } from "@pages/Peripherals/CashManagement/CashManagementConfigure";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import PrepheralCardFooter from "../PrepheralCardFooter";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import { ConfirmationMessageEditPeripheral } from "@components/Common/ConfirmationMessageEditPeripheral";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";

import { useCashManagement } from "./useCashManagement";
import { PERIPHERAL_FORM_CARD_STYLE } from "../styles";

import "../../index.css";

type DeviceAssociateModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
    selectedRows: any;
};
export default function CashManagement({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
    selectedRows,
}: DeviceAssociateModalType) {
    const {
        t,
        getAuthHeader,
        oneShop,
        userID,
        franchiseID,
        shopID,
        isAddPeripheralClicked,
        setIsAddPeripheralClicked,
        modify,
        isModalOpened,
        setIsModalOpened,
        isDataCashManagementUpdated,
        setIsDataCashManagementUpdated,
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
        filterActive,
        setLocalFilterActive,
        isAddNewCashManagementButtonClicked,
        isEdited,
        setIsEdited,
        shopId,
        i18nextLng,
        editedData,
        setEditedData,
        data,
        setData,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
        inputDesignation,
        setInputDesignation,
        inputMarque,
        setInputMarque,
        inputIp,
        setInputIp,
        applications,
        arrayOfCustomColumns,
        customJsxComponent,
    } = useCashManagement({ rowData, selectedRows });

    return (
        <React.Fragment>
            <CardBody className="p-1" style={PERIPHERAL_FORM_CARD_STYLE}>
                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddPeripheralClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        marginBottom: isAddPeripheralClicked ? "70px" : "0px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        url={`${
                            process.env.REACT_APP_API_V2_URL
                        }/settings/cash_management?userId=${userID}&shopId=${
                            oneShop
                                ? shopID
                                : selectedRows.length !== 0 &&
                                  selectedRows.filter(
                                      (elt: any) => elt[t("Application")] !== ""
                                  )[0] !== undefined
                                ? selectedRows.filter(
                                      (elt: any) => elt[t("Application")] !== ""
                                  )[0].shopId
                                : rowData.shopId
                        }&franchiseId=${franchiseID}&typeDisplay=notArchived`}
                        customJsxSideFilterButton={
                            isAddPeripheralClicked !== true &&
                            modify === true ? (
                                <div className="d-flex justify-content-start align-items-center">
                                    <span
                                        onClick={() => {
                                            setEditedData([]);
                                            setIsAddPeripheralClicked(
                                                !isAddPeripheralClicked
                                            );
                                        }}
                                        className={`${classnames(
                                            "afa_btn_addPeripheral",
                                            {
                                                "not-allowed-icon__clz":
                                                    applications.length > 1,
                                            }
                                        )}`}
                                    >
                                        <CustomMainColorButtonWithIcon
                                            icon="PlusIcon"
                                            iconPosition="left"
                                            className="w-100"
                                            style={{ height: "0px" }}
                                            rounded
                                            variant="primary"
                                        >
                                            {t("Add device")}
                                        </CustomMainColorButtonWithIcon>
                                    </span>
                                </div>
                            ) : modify === true ? (
                                <div className="d-flex justify-content-start">
                                    <CustomMainColorIconButton
                                        icon="PlusIcon"
                                        rounded
                                        onClick={() => {
                                            if (isEdited === true)
                                                setIsInInitializationModalOpened(
                                                    true
                                                );
                                            else {
                                                setInputDesignation(false);
                                                setInputMarque(false);
                                            }
                                        }}
                                        disabled={
                                            editedData.length === 0
                                                ? false
                                                : true
                                        }
                                    >
                                        <PlusIcon
                                            height={20}
                                            width={20}
                                            fill="white"
                                        />
                                    </CustomMainColorIconButton>
                                </div>
                            ) : null
                        }
                        setDataIsUpdated={setIsDataCashManagementUpdated}
                        dataIsUpdated={isDataCashManagementUpdated}
                        showGlobalFilter
                        setData={setData}
                        actionColumn={customJsxComponent}
                        filterActive={filterActive}
                        setLocalFilterActive={setLocalFilterActive}
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        minHeight="520px"
                        maxHeight="520px"
                    />
                    {isAddPeripheralClicked ? (
                        <CashManagementConfigure
                            setIsAddCashManagementClicked={
                                setIsAddPeripheralClicked!
                            }
                            isAddCashManagementClicked={isAddPeripheralClicked}
                            setDataIsUpdated={setIsDataCashManagementUpdated}
                            editedData={editedData}
                            setEditedData={setEditedData}
                            isAddNewCashManagementButtonClicked={
                                isAddNewCashManagementButtonClicked
                            }
                            shopId={shopId}
                            isEdited={isEdited}
                            setIsEdited={setIsEdited}
                            localShopId={
                                oneShop
                                    ? [shopID]
                                    : [
                                          selectedRows.length !== 0 &&
                                          selectedRows.filter(
                                              (elt: any) =>
                                                  elt[t("Application")] !== ""
                                          )[0] !== undefined
                                              ? selectedRows.filter(
                                                    (elt: any) =>
                                                        elt[
                                                            t("Application")
                                                        ] !== ""
                                                )[0].shopId
                                              : rowData.shopId,
                                      ]
                            }
                            setInputDesignation={setInputDesignation}
                            inputDesignation={inputDesignation}
                            setInputMarque={setInputMarque}
                            inputMarque={inputMarque}
                            setInputIp={setInputIp}
                            inputIp={inputIp}
                            dataTable={data}
                            isConsult={false}
                            setIsConsult={() => {}}
                        />
                    ) : null}
                </div>
            </CardBody>
            {!isAddPeripheralClicked ? (
                <PrepheralCardFooter
                    dataIsUpdated={dataIsUpdated}
                    setIsEdited={setIsEdited}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    rowData={rowData}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
            {isModalDeleteAssociatePeripheralOpened === false ? (
                <ConfirmationDeleteMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setDataIsUpdated={setIsDataCashManagementUpdated}
                    text={t("Please confirm archivation of this device")}
                    message={t("The device was successfully archived")}
                    apiUrl={`${
                        process.env.REACT_APP_API_V2_URL
                    }/settings/cashManagement?userId=${userID}&shopId=${
                        oneShop ? shopID : rowData.shopId
                    }&franchiseId=${franchiseID}&id=""&isArchived=true`}
                    setGlobalDataIsUpdated={setDataIsUpdated}
                    data={{ shopId: shopId }}
                />
            ) : (
                <AlertDeletePeripheralMessage
                    text={t(
                        "This device is associated with one or more applications! Unable to perform delete action"
                    )}
                    isModalDeleteAssociatePeripheralOpened={
                        isModalDeleteAssociatePeripheralOpened
                    }
                    setIsModalDeleteAssociatePeripheralOpened={
                        setIsModalDeleteAssociatePeripheralOpened
                    }
                />
            )}
            {isInInitializationModalOpened === true ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddPeripheralClicked}
                    isClicked={isAddPeripheralClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isConfirmationEditRunning === true ? (
                <ConfirmationMessageEditPeripheral
                    isModalOpened={isConfirmationEditRunning}
                    setIsModalOpened={setIsConfirmationEditRunning}
                    setCancel={setIsAddPeripheralClicked}
                    archive={false}
                />
            ) : null}
        </React.Fragment>
    );
}
